import { InitiativeStatus } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'

export enum KeyInitiativesQuickFilter {
  WithoutFinancialTargets = 'withoutFinancialTargets',
  LowDescriptionQuality = 'lowDescriptionQuality',
  WithoutBusinessPriorities = 'withoutBusinessPriorities',
}

export interface IKeyInitiativesFiltersForm {
  strategicInitiatives: string[]
  businessPriorities: string[]
  statuses: InitiativeStatus[]
  countryCodes: string[]

  keyInitiativesIds?: number[]
  quickFilter?: KeyInitiativesQuickFilter | null
}

export enum DashboardGroupBy {
  StrategicInitiative = 'Strategic Initiative',
  BusinessPriority = 'Business Priority',
  BusinessUnit = 'Business Unit',
  Period = 'Period',
  Status = 'Status',
}

export enum DashboardChartMeasure {
  Goal = 'Goal',
  Incremental = 'Incremental',
  Count = 'Count',
}

export interface IKeyInitiativesControlsForm {
  groupBy: DashboardGroupBy
  chartMeasure: DashboardChartMeasure
}

export interface IScoreCard {
  titleKey: string
  descriptionKey: string
  bandTranslationKeys?: { low: string; moderate: string; high: string }
}
